// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3DYaf","inputWrap":"styles_inputWrap__38ekh","input":"styles_input__1U_HN"};